import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { PaginationArgs, BookingDataAdministrationResult, BookingData, AdministrationResultStatus, ServiceDataPaginationDataAdministrationResult, AddBookingData } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class BookingService {
  constructor(private systemApiClient: SystemApiClient) { }

  retrieveAllBookings(): Observable<ServiceDataPaginationDataAdministrationResult>  {
    return this.systemApiClient.retrieveAllBookings();
  }
  
  retrieveBookingById(bookingId: number | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.retrieveBookingById(bookingId);
  }

  addBooking(body: AddBookingData | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.addBooking(body);
  }

  cancelBooking(bookingId: number | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.cancelBooking(bookingId);
  }

  retrieveBookingByBookingToken(token: string | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.retrieveBookingByBookingToken(token);
  }

  retrieveBookingInfoById(bookingId: number | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.retrieveBookingInfoById(bookingId);
  }

  retrieveAllBookingsPaginated(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult> {
    return this.systemApiClient.retrieveAllBookingsPaginated(body);
  }

  retrieveBookingsByUserIdPaginated(userId: number | undefined, body: PaginationArgs | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.retrieveBookingsByUserIdPaginated(userId, body);
  }

  retrieveBookingsByUserId(userId: number | undefined): Observable<BookingDataAdministrationResult> {
    return this.systemApiClient.retrieveBookingsByUserId(userId);
  }
}